export enum SetPasswordBackendError {
  PasswordExpired = 'password-expired',
  PasswordRequired = 'password-required',
  PasswordMatchPasswordCheck = 'password-match-password-check',
  WeakPassword = 'weak-password',
}

export const isSetPasswordBackendError = (value: unknown): value is SetPasswordBackendError =>
  typeof value === 'string' && Object.values(SetPasswordBackendError).some(item => item === value);

export const SET_PASSWORD_FORM_INITIAL_VALUES = {
  password: '',
  passwordCheck: '',
} as const;

export const OTP_VALIDITY_DURATION = 3 * 60 * 1000; // 3 minutes in milliseconds
